export default class Navigation {

    /**
     * Toggle Burger Menu Navigation
     */
    toggleMobileNavigation(navIcon, navbarNav, subNav) {
        navIcon.classList.toggle('open');
        navbarNav.classList.toggle('show');
        subNav.forEach((element) => {
            element.classList.toggle('show');
        });
    }

    /**
     * Custom Navigation for touch events
     */
    showTouchNavigation(element, event, mainMenu, subMenues) {

        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth > 991) {
            if (!element.classList.contains('follow') && element.children[1]) {
                event.preventDefault();
            }
            subMenues.forEach(element => element.classList.remove('active'));
            mainMenu.forEach(element => element.classList.remove('follow'));
            element.classList.add('follow');
        }
    }

    /**
     * On Resize hide Mobile Navigations
     */
    hideCanvasNavigation(navIcon, navbarNav, subNav) {
        navIcon.classList.remove('open');
        navbarNav.classList.remove('show');
        subNav.forEach((element) => {
            element.classList.remove('show');
        });
    }
}
